export const links = [
    {
        title: 'homeLink',
        link: '/'
    },
    {
        title: 'aboutLink',
        link: '/about'
    },
    {
        title: 'usersLink',
        link: '/users'
    },
    {
        title: 'productsLink',
        link: '/products'
    },
    {
        title: 'mapLink',
        link: '/map'
    },
    {
        title: 'becomePartner',
        link: '/partners-info'
    }
    // {
    //     title: 'partnersLink',
    //     link: '/partners'
    // }
]